import AbstractPolyShape from "./AbstractPolyShape";

export default class Polygon extends AbstractPolyShape {
    type = 'polygon';

    constructor(provider, data, appearance, speciesIds, label) {
        super(provider, data, appearance, speciesIds, label);
        this.close = this.p.CLOSE;
    }

    clone(dx, dy) {
        return new Polygon(
            this.provider,
            {
                coordinates: this.coordinates.map((c) => [c.absX + dx, c.absY + dy]),
            },
            this.appearance.clone(),
            this.speciesIds,
            this.labels.clone(),
        );
    }

    hovered() {
        let passings = 0;
        for (let i = 0; i < this.coordinates.length; i++) {
            let c1 = this.coordinates[i];
            let c2 = this.coordinates[(i + 1) % this.coordinates.length];
            // straight line, so irrelevant.
            if (c1.currentY == c2.currentY) {
                continue;
            }
            // line is below mouse
            if (c1.currentY < this.view.currentY && c2.currentY < this.view.currentY) {
                continue;
            }
            // line is above mouse
            if (c1.currentY > this.view.currentY && c2.currentY > this.view.currentY) {
                continue;
            }
            // calculate x value on line
            let x = c1.currentX + (this.view.currentY - c1.currentY) * (c2.currentX - c1.currentX) / (c2.currentY - c1.currentY);
            if (x > this.view.currentX) {
                passings++;
            }
        }
        return passings % 2 == 1;
    }

    getSegmentCoordinates(index) {
        return [
            this.coordinates[index],
            this.coordinates[(index + 1) % this.coordinates.length],
        ];
    }

    export() {
        return {
            type: 'polygon',
            data: {
                coordinates: this.coordinates.map((c) => [c.absX, c.absY]),
                notes: this.notes,
                ...this.appearance.export(),
                ...this.labels.export(),
            },
            speciesIds: this.speciesIds,
        }
    }

    isPolygon() {
        return true;
    }

    get length() {
        return this.coordinates.length;
    }

    get title() {
        return 'Free shape';
    }
}
